import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ResourceWithLink from './ResourceWithLink';

// Styled version of ResourceWithLink component.
export const NoDataPlaceholder = ({className, placeholder, onPlaceholderClickConfig}) => {
	return (
		<StyledNoDataPlaceholder
			className={`StyledNoDataPlaceholder ${className}`}
			placeholder={placeholder}
			onPlaceholderClickConfig={onPlaceholderClickConfig}
		/>
	);
};

NoDataPlaceholder.propTypes = {
	className: PropTypes.string,
	placeholder: PropTypes.string,
	onPlaceholderClickConfig: PropTypes.func
};

export default NoDataPlaceholder;

const StyledNoDataPlaceholder = styled(ResourceWithLink)`
	justify-content: center;
	align-items: center;
	min-height: inherit;
	max-height: inherit;
	align-content: center;
	color: var(--neutrals-700);
	display: flex;
	flex-direction: column;
	&.StyledResourceWithLink {
		.createRichTextElementSpanWrapper {
			//display: flex;
		}
		a {
			display: inline-flex;
			justify-content: center;
			font-weight: bold !important;
			margin-left: var(--px-5);
		}
	}
	span {
		font-size: var(--px-16);
		text-align: center;
		a {
			font-weight: bold;
			cursor: pointer;
			font-size: var(--px-14);
			color: var(--blue-600);
		}
	}
`;
